import { render, staticRenderFns } from "./VAdminUserCard.vue?vue&type=template&id=5b59706c"
import script from "./VAdminUserCard.vue?vue&type=script&lang=js"
export * from "./VAdminUserCard.vue?vue&type=script&lang=js"
import style0 from "./VAdminUserCard.vue?vue&type=style&index=0&id=5b59706c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports